import React, { useEffect, useMemo, useState } from 'react';
import './BuyCreditsModal.css';
import axiosPrivate from 'config/axiosPrivate';
import { useTranslation } from 'react-i18next';
const CREDIT_PACKS = [
  { id: '100', credits: 100, price: '5 €', apiValue: 'SMALL' },
  { id: '200', credits: 200, price: '12,5 €', apiValue: 'MEDIUM' },
  { id: '500', credits: 500, price: '22,5 €', apiValue: 'LARGE' },
  { id: '1000', credits: 1000, price: '50 €', apiValue: 'XL' },
];

export default function BuyCreditsModal({ open, onClose }) {
  const { t } = useTranslation();
  const [selectedPackId, setSelectedPackId] = useState('500');
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [paymentError, setPaymentError] = useState('');

  const selectedPack = useMemo(
    () => CREDIT_PACKS.find((pack) => pack.id === selectedPackId) || CREDIT_PACKS[0],
    [selectedPackId]
  );

  useEffect(() => {
    if (open) {
      setIsRedirecting(false);
      setPaymentError('');
    }
  }, [open]);

  const handleGoToPayment = async () => {
    if (!selectedPack?.id || isRedirecting) return;

    setIsRedirecting(true);
    setPaymentError('');

    try {
      const response = await axiosPrivate.get('/payment/api/subscriptions/generate-credits-checkout-url', {
        params: {
          creditPack: selectedPack.apiValue,
        },
      });

      const checkoutUrl =
        response?.data?.checkoutUrl ||
        response?.data?.url ||
        response?.data?.data?.checkoutUrl ||
        response?.data?.data?.url ||
        (typeof response?.data === 'string' ? response.data : null);

      if (!checkoutUrl) {
        throw new Error('Checkout URL missing');
      }

      window.location.assign(checkoutUrl);
    } catch (error) {
      setIsRedirecting(false);
      setPaymentError("Impossible de lancer le paiement pour le moment. Merci de réessayer.");
    }
  };

  if (!open) return null;

  return (
    <div className="bcm-overlay" onClick={onClose}>
      <div
        className="bcm-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Ajouter des crédits supplémentaires"
      >
        <div className="bcm-header">
          <div>
            <h2 className="bcm-title">{t('Ajouter des crédits supplémentaires')}</h2>
            <p className="bcm-subtitle">
              {t('Ajoutez des crédits pour continuer à générer du contenu avec vos agents IA. Les crédits sont consommés à chaque utilisation, selon le type de génération.')}
              
            </p>
          </div>
          <button
            type="button"
            className="bcm-close"
            onClick={onClose}
            aria-label="Fermer la fenêtre"
          >
            ×
          </button>
        </div>

        <div className="bcm-packs">
          {CREDIT_PACKS.map((pack) => (
            <button
              type="button"
              key={pack.id}
              className={`bcm-pack ${selectedPackId === pack.id ? 'is-selected' : ''}`}
              onClick={() => setSelectedPackId(pack.id)}
            >
              <div className="bcm-pack-credits">{pack.credits} {t('crédits')}</div>
              <div className="bcm-pack-price">{pack.price}</div>
            </button>
          ))}
        </div>

        <div className="bcm-note">{t('Utilisables immédiatement • Valables pour le mois en cours')}</div>

        <div className="bcm-footer">
          <button type="button" className="bcm-btn bcm-btn--ghost" onClick={onClose}>
            {t('Annuler')}
          </button>
          <button
            type="button"
            className="bcm-btn bcm-btn--primary"
            onClick={handleGoToPayment}
            disabled={isRedirecting}
          >
            {isRedirecting ? t('Redirection...') : t('Continuer vers le paiement')}
          </button>
        </div>
        {paymentError && <p className="bcm-error">{paymentError}</p>}
      <div className="bcm-footer-note" >
      <span className="bcm-footer-subn">
           {t('Vous serez redirigé vers notre page de paiement sécurisée (Stripe).')}
          </span>
          </div> 
      </div>
    </div>
  );
}
